jQuery(function($)
{
    var
        $htmlBody = $('html, body'),
        $offsetElement = $('header .onsite-container'),
        offset = 50 + ((0 === $offsetElement.length) ? 0 : $offsetElement.outerHeight(true));

    function handleClick(e)
    {
        console.log('scrolltrigger.js handleClick');
        var $scrollTrigger = $(this),
            scrollTargetId;

        if ($scrollTrigger.attr('data-scroll-to-id'))
        {
            scrollTargetId = '#' + $scrollTrigger.attr('data-scroll-to-id');
        }
        else
        {
            scrollTargetId = $scrollTrigger.attr('href');
        }

        var $scrollTarget = $(scrollTargetId);

        $htmlBody.animate({
            'scrollTop': $scrollTarget.offset().top - offset
        });

        e.preventDefault();
    }

    $('body').on('click', '.scroll-trigger', handleClick);
});
